import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { frFR } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { type Dayjs } from 'dayjs';
import 'dayjs/locale/fr';

// -- type definitions --

export interface ThresholdPeriodRangePickerProps {
  label: string;
  value: [string, string];
  onChange: (value: [string, string]) => void;
  helperText?: string;
  error?: boolean;
}

// -- functions --

const toDayjsValue = (value: string): Dayjs | null => {
  if (!value) {
    return null;
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

// -- main component --

export function ThresholdPeriodRangePicker({
  label,
  value,
  onChange,
  helperText = 'Optionnel',
  error = false,
}: ThresholdPeriodRangePickerProps) {
  const currentValue: [Dayjs | null, Dayjs | null] = [
    toDayjsValue(value[0]),
    toDayjsValue(value[1]),
  ];

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="fr"
      localeText={
        frFR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <DateRangePicker
        label={label}
        value={currentValue}
        onChange={(newValue) => {
          if (!newValue) {
            onChange(['', '']);
            return;
          }

          onChange([
            newValue[0] ? newValue[0].toISOString() : '',
            newValue[1] ? newValue[1].toISOString() : '',
          ]);
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            helperText,
            error,
            InputLabelProps: { shrink: true },
          },
          field: { clearable: true },
        }}
      />
    </LocalizationProvider>
  );
}
